



import React, { useEffect } from 'react'
// import CustomTable from '../../Components/Table/CustomTable';

import { Grid } from '@mui/material';

import { useDispatch } from 'react-redux';
import CustomTable from '../../../../Components/Table/CustomTable';
import AllUserTableViewModal from '../../../OperatorRegistration/Modal/AllUserTableViewModal';
// import { setHeaderName } from '../../../ReduxStore/Slices/headerSlice';
// import { setHeaderName } from './headerSlice';


const TotalPendingRegisration = () => {

    const tableData = [
        { Name: 'Vallarasu', Email: "valla@gmail.com", MobileNumber: "1232343444", UserType: "Individual", Status: "Pending" },
        { Name: 'Pravin', Email: "pravin@gmail.com", MobileNumber: "98787687687", UserType: "Individual", Status: "Pending" },
        { Name: 'Shahul', Email: "shahul@gmail.com", MobileNumber: "123322443543", UserType: "Individual", Status: "Pending" },
        { Name: 'Ramesh', Email: "Ramesh@gmail.com", MobileNumber: "76575675664", UserType: "Individual", Status: "Pending" },
        { Name: 'Sanjeev', Email: "Sanjeev@gmail.com", MobileNumber: "909878789709", UserType: "Financial Consultant", Status: "Pending" },

        { Name: 'Vallarasu', Email: "valla@gmail.com", MobileNumber: "1232343444", UserType: "Individual", Status: "Pending" },
        { Name: 'Pravin', Email: "pravin@gmail.com", MobileNumber: "98787687687", UserType: "Individual", Status: "Pending" },
        { Name: 'Shahul', Email: "shahul@gmail.com", MobileNumber: "123322443543", UserType: "Individual", Status: "Pending" },
        { Name: 'Ramesh', Email: "Ramesh@gmail.com", MobileNumber: "76575675664", UserType: "Individual", Status: "Pending" },
        { Name: 'Sanjeev', Email: "Sanjeev@gmail.com", MobileNumber: "909878789709", UserType: "Financial Consultant", Status: "Pending" },


    ];

    
    const tableHeadData = ['S.No', 'Name', "Email", "Mobile Number", "User Type", 'Status'];

    return (
        <Grid container spacing={2}>

            <Grid item xs={12} sx={{ width: "100px" }}>
                <CustomTable tableData={tableData} title="User List" tableHeadData={tableHeadData}
                    rowPerPage={10}
                    tableView="tableView"
                    tableSearch="tableSearch"
                    dataCreate="dataCreate"
                    // tableEdit="tableEdit"
                    // tableDelete="tableDelete"
                    // modalName={UserCreateByOperatorModal}
                    allShowModal="allShowModal"
                    modalVeiwName={AllUserTableViewModal}
                    modalViewHeadingName="User Detail"

                    modalHeadingName="Create User"
                />

            </Grid>
        </Grid>
    )
}

export default TotalPendingRegisration